module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADCSURBVEhL7c29CcJQFMXxJ3Za2DiBQ1jZuIngEg4hwQm0dQVLCwfRSlsn8NwXD4ok9933EbDIHw7JDYGf6+uyCbbBhv7qIAEu2A07YMUhAjtsjJ2wotA3MJAPaIQVg5oAVgTSAJYFacD0/WRJkAassSe28NenKCgEXLEV9sCSIAsw85dzS0yD9lgjdMYsABPojrVBlb9+kp+tANOgef2qFwJYGxTMCrBoKBZgZigVYEEoF2AqdMRyASbQtn7t+7+cewGnIDiwJZfqUgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons8-double-up-25.png
// module id = 1183
// module chunks = 0